export const cases = [
  {
    id: 'nominativ',
    category: 'kasus',
    level: 'A1',
    title: 'Nominativ (Rasti Emëror)',
    detailedContent: `
      <section>
        <p><b>Nominativ</b> ose "Rasti Emëror" është rasti bazë (themelor) i një emri në gjuhën gjermane. Sido që ta gjeni një fjalë në fjalor, ajo do të jetë gjithmonë në rastin Nominativ.</p>
        
        <h3>1. Kur përdoret Nominativ-i?</h3>
        <ul>
          <li><b>Subjekti i fjalisë:</b> Kryefjala - kush e kryen veprimin.</li>
          <li><b>Me foljen "sein" (jam):</b> Kur folja kryesore në fjali është "sein", emri që vjen pas saj NUK është objekt, por është një pjesë e kallëzuesit emëror. Pra, gjendet në Nominativ.</li>
          <li><b>Me foljet "werden" dhe "bleiben":</b> Ashtu si "sein", edhe pas foljes "werden" dhe "bleiben" ne përdorim sërish Nominativ.</li>
        </ul>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Pyetja për të gjetur Nominativ:</strong> 
          <br><b>Wer?</b> (Kush? - për njerëz) ose <b>Was?</b> (Çfarë? - për sende/koncepte)
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Nyjet në Nominativ',
        headers: ['Gjinia', 'Nyja e Shquar', 'Nyja e Pashquar', 'Nyja Mohuese', 'Nyja Pronore (ich)'],
        rows: [
          ['Maskulin (Mashkullore)', 'der', 'ein', 'kein', 'mein'],
          ['Feminin (Femërore)', 'die', 'eine', 'keine', 'meine'],
          ['Neutral (Asnjanëse)', 'das', 'ein', 'kein', 'mein'],
          ['Plural (Shumës - Të gjitha)', 'die', '-', 'keine', 'meine']
        ]
      }
    ],
    examples: [
      { ger: 'Der Mann liest ein Buch.', alb: 'Burri lexon një libër. (Kush lexon? Burri -> Der Mann është subjekti = Nominativ)' },
      { ger: 'Das ist mein Vater.', alb: 'Ky është babai im. (Pas foljes "ist" vjen përsëri Nominativ: mein Vater)' },
      { ger: 'Er wird Lehrer.', alb: 'Ai do të bëhet mësues. (Me "werden" -> Nominativ)' }
    ],
    exercises: [
      { question: 'Pse fjala "Lehrer" në fjalinë "Er ist ein guter Lehrer" qëndron në Nominativ?', options: ['Sepse tregon profesion', 'Sepse pason foljen "sein" (ist) dhe jo një folje veprimi tranzitive.', 'Sepse është burrë'], correct: 1, explanation: 'Foljet sein, werden, dhe bleiben kërkojnë Nominativ mbas tyre sepse përbëjnë vetëm kallëzues emëror.' }
    ]
  },
  {
    id: 'akkusativ',
    category: 'kasus',
    level: 'A2',
    title: 'Akkusativ (Rasti Kundrinor i Drejtë)',
    detailedContent: `
      <section>
        <p><b>Akkusativ</b> shërben për të treguar Kundrinorin e Drejtë (Akkusativobjekt). Është rasti i personit ose sendit që e pëson drejtpërdrejt veprimin.</p>

        <h3>1. Kur përdoret?</h3>
        <ul>
          <li><b>Si objekt i drejtpërdrejtë i shumicës së foljeve:</b> P.sh.: sehen (shoh), haben (kam), machen (bëj), lieben (dua), kaufen (blej). <i>Ich kaufe den Apfel (Unë blej mollën - mollën në Akkusativ).</i></li>
          <li><b>Pas disa parafjalëve të caktuara:</b> durch, für, gegen, ohne, um. Këto marrin GJITHMOMË dhe MËNJËHERË mbas tyre Akkusativ.</li>
          <li><b>Për kohën (si tregues):</b> "jeden Tag", "letzten Monat", "dieses Jahr".</li>
          <li><b>Pas foljeve të lëvizjes (+ Wechselpräpositionen):</b> Nëse folja thekson lëvizjen DREJT diku-t (Wohin?), parafjalët lëvizëse (in, auf, an) do të duan Akkusativ-in. P.sh.: <i>Ich gehe in <b>den</b> Park.</i></li>
        </ul>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Pyetja për të gjetur Akkusativ:</strong> 
          <br><b>Wen?</b> (Kë? - për njerëz) ose <b>Was?</b> (Çfarë? - për sende)
          <br><b>Wohin?</b> (Për ku?) (për Lëvizje)
        </div>

        <h3>2. Çfarë Ndryshon?</h3>
        <p>I vetmi dhe më i rëndësishmi ndryshim mbetet <b>Gjinia Mashkullore (Der -> Den)</b>. Gjinitë e tjera: Femërorja, Asnjanësja dhe Shumësi NGELEN NJËSOJ SI NË NOMINATIV! Ky është rregull i artë.</p>
      </section>
    `,
    tables: [
      {
        label: 'Ndryshimet e Nyjeve në Akkusativ',
        headers: ['Gjinia', 'Nominativ -> Akkusativ (E shquar)', 'Nyja e pashquar (Akk)', 'Shembull (pronor)'],
        rows: [
          ['Maskulin', 'der -> <b>den</b> (Kujdes!)', 'einen', 'meinen'],
          ['Feminin', 'die -> die (s\'ndryshon)', 'eine', 'meine'],
          ['Neutral', 'das -> das (s\'ndryshon)', 'ein', 'mein'],
          ['Plural', 'die -> die (s\'ndryshon)', '-', 'meine']
        ]
      }
    ],
    examples: [
      { ger: 'Ich sehe den Mann.', alb: 'Unë shoh burrin. (Kë shoh? den Mann -> Mashkullore Akkusativ)' },
      { ger: 'Wir haben einen Hund und eine Katze.', alb: 'Ne kemi një qen (einen - mashk. Akk) dhe një mace (eine - femër. Akk)' },
      { ger: 'Ich lerne jeden Tag Deutsch.', alb: 'Unë mësoj çdo ditë (jeden Tag - Akkusativ i kohës) gjermanisht.' }
    ],
    exercises: [
      { question: 'Pse përdoret "den" tek fjalia: "Er represents den Lehrer"?', options: ['Sepse ai po bëhet mësues', 'Sepse folja kërkon Akusativ dhe Lehrer është Mashkullor.', 'Sepse theksohet nominativi.'], correct: 1, explanation: 'Lehrer është "der Lehrer". Objekti bie drejtperdrejte ne Akusativ tek der->den.' }
    ]
  },
  {
    id: 'dativ',
    category: 'kasus',
    level: 'A2',
    title: 'Dativ (Rasti i Zhdrejtë - Dhanorja)',
    detailedContent: `
      <section>
        <p><b>Dativ</b> ngjan shpesh me Dhanoren në Shqip (Kujt ia jep?/Kujt i flet?). Gjithashtu ky tregon vendndodhjen fikse pa lëvizje kur bashkëpunohet me një parafjalë thelbësore.</p>

        <h3>1. Kur përdoret Dativ-i?</h3>
        <ul>
          <li><b>Dativobjekt (Objekti i Zhdrejtë):</b> Folje të cilat nuk prekin askënd direkt, por i PËRDJELLIN dikujt një thelb: helfen (ndihmoj), danken (falenderoj), antworten (përgjigjem), gefallen (më pëlqen/i pëlqen), gehören (i përket).<br/><i>Ich helfe <b>dir</b> (Unë <b>të</b> ndihmoj Ty).</i></li>
          <li><b>Me parafjalë fikse (të Dativ-it):</b> aus, bei, mit, nach, seit, von, zu. Mbas këtyre nuk ka diskutim; GJITHMONË vjen Dativi.</li>
          <li><b>Për vendndodhje (Wo?):</b> Kur parafjalët tregojnë vendndodhjen/pozicionin aktualisht dhe NUK ka lëvizje nga A në B (in, an, auf, unter etj). Pastaj këto marrin Dativ. <br/><i>Wir sind in <b>der</b> Schule (Ne jemi në shkollë).</i></li>
        </ul>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Pyetjet për të gjetur Dativ:</strong> 
          <br><b>Wem?</b> (Kujt?)
          <br><b>Wo?</b> (Ku?) (për Vendndodhjen Statike)
        </div>

        <h3>2. Çfarë Ndryshon?</h3>
        <p><b>TË GJITHA nyjet ndryshojnë në Dativ!</b></p>
        <p>Mashkullorja "der" -> "dem". Asnjanësja "das" -> "dem". Femërorja "die" -> "der" (Kujdes: Die=Femër -> Der=Dativ). Shumësi "die" -> "den" (Dhe i shtohet EMËRIT në fund një '-n').</p>
      </section>
    `,
    tables: [
      {
        label: 'Ndryshimet e Nyjeve në Dativ',
        headers: ['Gjinia', 'Nom -> Dativ (Shquar)', 'Pashquar', 'Emri Merr Fundore?'],
        rows: [
          ['Maskulin', 'der -> <b>dem</b>', 'einem', 'JO'],
          ['Feminin', 'die -> <b>der</b>', 'einer', 'JO'],
          ['Neutral', 'das -> <b>dem</b>', 'einem', 'JO'],
          ['Plural', 'die -> <b>den</b>', '-', '<b>PO (-n ose -en)</b> te emri, psh. den Kinder<b>n</b>']
        ]
      }
    ],
    examples: [
      { ger: 'Ich danke dem Mann.', alb: 'Unë e falenderoj burrin. (Kujt i them faleminderit? Burrit -> dem Mann)' },
      { ger: 'Wie geht es der Frau?', alb: 'Si i shkon gruas? ("Wie geht es..." kërkon gjithmonë Dativ, ndaj die Frau -> der Frau)' },
      { ger: 'Die Bücher helfen den Studenten.', alb: 'Librat i ndihmojnë studentët. (Shumës dativ: die -> den, Studenten)' }
    ],
    exercises: [
      { question: 'Zgjidh formën e saktë: "Das Buch gehört ___ Frau."', options: ['die', 'der', 'den'], correct: 1, explanation: 'Folja "gehören" kalon me Dativ. Gruaja është "die Frau", dhe në Dativ "die" kthehet në "der".' },
      { question: 'Çfarë shtese marrin të gjithë emrat në shumës në rastin Dativ (me përjashtim të atyre që mbarojnë me -s)?', options: ['-s', '-e', '-n'], correct: 2, explanation: 'Në asnjëherë shumës Dativ emri baza në fund merr "-n" për të forcuar ndjenjen vendore e fjales psh(den Kindern, den Autos-perjashtim, den Häusern).' }
    ]
  },
  {
    id: 'genitiv',
    category: 'kasus',
    level: 'B1',
    title: 'Genitiv (Rasti Pronor)',
    detailedContent: `
      <section>
        <p><b>Genitiv</b> përdoret për të treguar zotërim ose përkatësi ("I kujt? / E kujt?"). Në gjuhën e folur po zëvendësohet masivisht nga formulimi <b>"von + [Dativ]"</b>, por Genitivi mbetet forma super zyrtare, elegante dhe shumë e përdorur në tekste, universitete dhe letërsi.</p>

        <h3>1. Kur përdoret Genitiv-i?</h3>
        <ul>
          <li><b>Pronësia:</b> P.sh.: Makina e babait -> <i>Das Auto <b>des Vaters</b></i>. E kundërta thellë joformale: Das Auto <i>von dem</i> Vater.</li>
          <li><b>Emrat propër (emrat e njerëzve/qyteteve):</b> Marrin thejesht një "-s" nga pas. <i>Annas Buch</i> (Libri i Anës). <i>Deutschlands Wirtschaft</i> (Ekonomia e Gjermanisë).</li>
          <li><b>Me parafjalë të rrepta të Genitiv-it:</b> wegen (për shkak të), während (gjatë), trotz (pavarësisht rrethanave), statt/anstatt (në vend të).</li>
        </ul>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Pyetja për të gjetur Genitiv:</strong> 
          <br><b>Wessen?</b> (I/e kujt?)
        </div>

        <h3>2. Çfarë Ndryshon dhe rregulli i saktë i EMRAVE?</h3>
        <p>Në Genitiv nuk ndryshojnë thjeshtë nyjet, por TEK MASHKULLORJA U SHTOHET EMRAVE "-(e)s" NË FUND!</p>
        <ul>
          <li><b>der -> des</b> (+ emri merr -s ose -es).</li>
          <li><b>das -> des</b> (+ emri merr -s ose -es).</li>
          <li><b>die -> der</b> (Emri i femrës nuk merr kurrë -s nga pas).</li>
          <li><b>die (Pl.) -> der</b> (Emrat shumës nuk e marrin s-në nga prapa extra për shkak se jan ne plural form).</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Ndryshimet themelore në Genitiv',
        headers: ['Gjinia', 'Nom -> Genitiv', 'Nyja e pashquar', 'Emri'],
        rows: [
          ['Maskulin', 'der -> <b>des</b>', 'eines', '+ -(e)s (des Vaters)'],
          ['Feminin', 'die -> <b>der</b>', 'einer', 'asnjë ndryshim (der Frau)'],
          ['Neutral', 'das -> <b>des</b>', 'eines', '+ -(e)s (des Kindes)'],
          ['Plural', 'die -> <b>der</b>', '-', 'asnjë ndryshim (der Kinder)']
        ]
      }
    ],
    examples: [
      { ger: 'Das Auto des Lehrers ist neu.', alb: 'Makina E mësuesit është e re. (des + lehrer+s)' },
      { ger: 'Trotz des schlechten Wetters gehen wir wandern.', alb: 'Pavarësisht motit TË KEQ, po shkojmë për eksplorim.' },
      { ger: 'Die Farbe der Blume ist wunderschön.', alb: 'Ngjyra E LULES është e mrekullueshme. (der Blume - nyja dhe jo ësht\' pa -s se është e femërore).' }
    ],
    exercises: [
      { question: 'Si kthehet në Genitiv: "Das Haus ____ ___" (Shtëpia e burrit)?', options: ['von der Mann', 'des Mannes', 'dem Männer'], correct: 1, explanation: 'Burri = der Mann. Në Genitiv: der -> des, dhe emri merr -es => des Mannes.' }
    ]
  },

  // Kasus me folje specifiche
  {
    id: 'akkusativobjekt',
    category: 'kasus',
    level: 'A2',
    title: 'Verben mit Akkusativobjekt',
    detailedContent: `
      <section>
        <p>Akkusativobjekt përfaqëson personin, kafshën, apo sendin që "goditet" drejtpërdrejt thellësisht nga folja. Zakonisht rreth 90% e foljeve me drejtim kalimtar kërkojnë prapa tyre menjehere dhe vetm Akuzativin.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Foljet Tipike:</strong> haben, brauchen, lesen, sehen, schreiben, kaufen, trinken, essen.
        </div>
        
        <p>Ne e formojme : Subjekt + folje + AKK !</p>
        <p><i>Ich habe einen Bleistift.</i> (Un kam nj laps).</p>
      </section>
    `,
    exercises: []
  },
  {
    id: 'dativobjekt',
    category: 'kasus',
    level: 'A2',
    title: 'Verben mit Dativobjekt',
    detailedContent: `
      <section>
        <p>Foljet e caktuara që nuk pranojn fare akuzativen por të dërgojnë vëmëndjen e tyre thelb tek Personi (Kujt? e jo Cfare goditet/merr).</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Lista thelbësorë (mëso përmendësh!):</strong> 
          <br>- <b>helfen</b> (ndihmoj)
          <br>- <b>danken</b> (falenderoj)
          <br>- <b>gratulieren</b> (uroj)
          <br>- <b>gehören</b> (i përkas)
          <br>- <b>gefallen</b> (më pëlqen)
          <br>- <b>schmecken</b> (shijon - për ushqim)
          <br>- <b>antworten</b> (I përgjigjem)
          <br>- <b>vertrauen</b> (Ii bësoj)
        </div>
        
        <p><i>Das Auto gehört dem Mann.</i> (jo den Mann). <i>Das Essen schmeckt der Frau gut.</i></p>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Ich gratuliere dir zum Geburtstag!', alb: 'Të uroj (TY) për ditëlindje! (Nuk mund të thuash "mich gratuliere", por "gratuliere DIR" - dativi i "du")' }
    ],
    exercises: []
  },

  // Kasus me parafjalë
  {
    id: 'praep-akk',
    category: 'kasus',
    level: 'B1',
    title: 'Präpositionen mit Akkusativ (Parafjalët me Akuzativ)',
    detailedContent: `
      <section>
        <p>Sido të jetë thelbi, sapo të shihni në fjali një nga këto 5 parafjalë klasike, fjala që vjen mbas do KTHEHET URGJENTISHT në Akkusativ.</p>
        
        <h3>1. Parafjalët "D-U-F-E-OG" / "D-O-G-F-U"</h3>
        <ul>
          <li><b>durch</b> - (Përmes / Nëpërmjet). <i>Wir gehen durch den Wald (përmes pyllit).</i></li>
          <li><b>für</b> - (Për). <i>Das Geschenk ist für dich (është për ty).</i></li>
          <li><b>gegen</b> - (Kundër/Kunrejt / Rreth kohes). <i>Ich bin gegen diesen Plan.</i></li>
          <li><b>ohne</b> - (Pa). <i>Ohne meinen Freund gehe ich nicht (Pa shokun tim ...).</i></li>
          <li><b>um</b> - (Rreth orës / Rreth e qark vendit). <i>Wir treffen uns um 8 Uhr. / Wir laufen um den Tisch.</i></li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'praep-dat',
    category: 'kasus',
    level: 'B1',
    title: 'Präpositionen mit Dativ (Parafjalët e Dativit)',
    detailedContent: `
      <section>
        <p>Këto parafjalë kërkojnë thjeshtë vetëm dhe KURRË tjetër gjithmonë <b>Dativin</b> mbas vetes. Nuk ka rëndësi nëse po flitet për lëvizje fizike me to.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Kënga thelbësore: "aus - außer - bei - mit - nach - seit - von - zu"</strong> (Këto janë Dativ!)
        </div>

        <ul>
          <li><b>aus</b> (nga - prejardhje / nga brenda-jashte). <i>Aus dem Haus.</i></li>
          <li><b>bei</b> (te / afer). <i>Ich bin beim Arzt (bei + dem).</i></li>
          <li><b>mit</b> (me). <i>Mit der Bahn spielen.</i></li>
          <li><b>nach</b> (pas / drejt qytetesishe). <i>Nach der Schule.</i></li>
          <li><b>seit</b> (që prej). <i>Seit einem Monat.</i></li>
          <li><b>von</b> (nga person/vend point). <i>Ein Geschenk von meiner Mutter.</i></li>
          <li><b>zu</b> (te/drejt njerëzve a thekshe ndryshem). <i>Zur Arbeit gehen (zu + der).</i></li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'praep-gen',
    category: 'kasus',
    level: 'B2',
    title: 'Präpositionen mit Genitiv',
    detailedContent: `
      <section>
        <p>Këto parafjalë janë akademike the super te perdoruashne formale gjuhësore.</p>
        <p>Marrin detyrimisht një Genitiv mbas (emrat marrin S-në):</p>
        <ul>
          <li><b>wegen</b> (për shkak të). <i>Wegen des Wetters bleiben wir zu Hause (Për shitëk të motit).</i></li>
          <li><b>während</b> (gjatë një thelbi kohore). <i>Während der Pause (Gjatë pushimit e jo nga).</i></li>
          <li><b>trotz</b> (pavarësisht rrethanave). <i>Trotz des Staus kam ich pünktlich an (Pavarësosh trafikut, arrita).</i></li>
          <li><b>statt / anstatt</b> (në vend të). <i>Statt eines Autos kaufte er ein Fahrrad. (Në vënd të një makinë - ai blrni).</i></li>
        </ul>
        <p>Shënim: Në të folurën e përditshme njerëzit përtojn ta perdorin dhe i thene thjesht me Dativ: "Wegen dem Wetter", por shkollimisht kjo mbetet ende teknikisht gabim/ose mbicilim thejsht rrugësh.</p>
      </section>
    `,
    exercises: []
  }
];
